// extracted by mini-css-extract-plugin
export var articleLink = "k_cx";
export var articleWrap = "k_cy";
export var avatar = "k_cF";
export var avatarImg = "k_cG";
export var content = "k_cz";
export var des = "k_cB";
export var img = "k_cJ";
export var imgWrap = "k_cH";
export var subtitle = "k_cD";
export var title = "k_cC";